
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createClient } from '@/lib/supabase-client'
import Sidebar from './Sidebar'
import DashboardHeader from './DashboardHeader'
import MultipleAPIKeysSection from './MultipleAPIKeysSection'

export default function APIKeyPage() {
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const supabase = createClient()

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session) {
      navigate('/auth/login')
      return
    }
    setLoading(false)
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900 flex items-center justify-center">
        <div className="text-center animate-fade-in">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 dark:border-primary-400"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-800">
      <Sidebar />
      <div className="lg:pl-64">
        <DashboardHeader title="API Key Management" />
        <main className="px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8 animate-fade-in">
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">API Key Management</h1>
            <p className="text-lg text-gray-600 dark:text-gray-400">Create and manage multiple API keys for different integrations</p>
          </div>
          <MultipleAPIKeysSection />
        </main>
      </div>
    </div>
  )
}

